import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getFacultyNavSections } from '../components/Sidebar/roleNavConfig';
import { isCbcFaculty } from '../utils/facultyRole';

const FacultyLayout = () => {
  const { user } = useAuth();
  const sections = useMemo(() => getFacultyNavSections({ user }), [user]);
  const shell = useMemo(() => {
    const isCbc = isCbcFaculty(user);
    return {
      homePath: '/faculty/dashboard',
      workspacePath: isCbc ? '/faculty/coding-dashboard' : '/faculty/dashboard',
      profilePath: '/faculty/profile',
      projectBasePath: isCbc ? null : '/faculty/project',
      codingRoot: isCbc ? '/faculty' : null,
      codingActivityPath: isCbc ? '/faculty/coding/activity' : null,
    };
  }, [user]);

  /** Absolute path — sidebar brand always goes to the faculty dashboard (CBC insights live there; batch list is under Coding workspace). */
  const brandPath = '/faculty/dashboard';

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath={brandPath} sections={sections}>
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default FacultyLayout;
